const faqs = [
  {
    q: '99漫画网需要付费吗？',
    a: '完全不需要！99漫画网所有漫画内容均为免费在线阅读，无需充值、无需会员。我们致力于为广大漫画爱好者提供零门槛的优质阅读体验。',
  },
  {
    q: '下拉式阅读是什么意思？',
    a: '下拉式阅读是一种纵向连续滚动的阅读方式，就像刷社交媒体一样向下滑动即可不断阅读。相比传统翻页模式，下拉式更流畅自然，特别适合韩漫那种长条格式的阅读体验。',
  },
  {
    q: '支持哪些类型的漫画？',
    a: '99漫画网覆盖韩漫、日漫、国漫三大品类。在题材上囊括恋爱、热血、奇幻、悬疑、搞笑、BL/GL、职场、科幻、古风等几乎所有热门分类，满足不同读者的口味偏好。',
  },
  {
    q: '如何收藏和追更漫画？',
    a: '点击作品详情页的收藏按钮即可将漫画加入你的书架。关注作品后，每当有最新章节更新时系统会为你推送提醒，确保你不会错过任何一话连载。',
  },
  {
    q: '手机可以看吗？有APP吗？',
    a: '当然可以！99漫画同时支持网页端和移动端访问。我们还提供iOS和Android版APP下载，APP端针对手机屏幕做了专属优化，支持离线缓存和夜间模式，阅读体验更佳。',
  },
  {
    q: '遇到加载慢或无法打开怎么办？',
    a: '建议先检查网络连接，或尝试切换Wi-Fi与移动数据。如果问题持续，可清理浏览器缓存后重试。APP端可在设置中调整图片清晰度来优化加载速度。如仍有问题欢迎通过联系我们页面反馈。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            关于99漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100/50 transition-colors list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 items-center justify-center shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}